import { createSlice } from "@reduxjs/toolkit";

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState: {
    data: null,
    error: null,
    isLoading: false,
  },
  reducers: {
    startSignUp: (state) => { state.isLoading = true; },
    setSignUp: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startSignUp, setSignUp } = signUpSlice.actions;
